export type CertTypeDef = {
  key: string
  label: string
}

export const DEFAULT_CERT_TYPE_DEFS: CertTypeDef[] = [
  { key: 'firstAidCprAed', label: 'First Aid CPR AED' },
  { key: 'osha', label: 'OSHA' },
  { key: 'bloodbornePathogens', label: 'Bloodborne Pathogens' },
  { key: 'radioFrequencySafety', label: 'Radio Frequency Safety' },
  { key: 'aerialLift', label: 'Aerial Lift' },
  { key: 'mewp', label: 'MEWP' },
  { key: 'towerClimber', label: 'Tower Climber' },
  { key: 'towerRigger', label: 'Tower Rigger' },
  { key: 'towerRescuer', label: 'Tower Rescuer' },
  { key: 'hazComSds', label: 'HazCom SDS' },
]

export const CERT_LABELS: Record<string, string> = Object.fromEntries(
  DEFAULT_CERT_TYPE_DEFS.map((item) => [item.key, item.label]),
)

export const MAX_CERT_TYPES = 40
export const MAX_CERT_TYPE_LABEL_LENGTH = 80

export function certLabel(type: string, catalog?: CertTypeDef[] | null): string {
  const key = String(type || '').trim()
  if (!key) return ''
  const match = catalog?.find((item) => item.key === key)
  if (match?.label) return match.label
  return CERT_LABELS[key] || key
}

export function certDisplayLabel(cert: { type?: string; label?: string | null }): string {
  const fromApi = String(cert?.label || '').trim()
  if (fromApi) return fromApi
  return certLabel(String(cert?.type || ''))
}
